import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const STEP_PARAM = 'step';

export default function useWizardStep(initialStep) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [step, setStepState] = useState(searchParams.get(STEP_PARAM) || initialStep);

  const setStep = useCallback(
    (nextStep) => {
      setStepState(nextStep);
      setSearchParams({ step: nextStep });
    },
    [setSearchParams]
  );

  return [step, setStep];
}
